// src/redux/thunks/deleteUserAccount.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
export const deleteUserAccount = createAsyncThunk(
  'user/deleteAccount',
  async (userId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(
        `${baseUrl}/users/hard-delete/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.status === 200) {
        return userId;
      } else {
        return rejectWithValue('Failed to delete account');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
